import { connect } from "react-redux";

import { SearchResults } from "./SearchResults";

import {
  getCars,
  getCalculationParams,
  getCalculationSummary,
  isResultsLoading,
  isLoadingMoreResults,
  getResultCount,
  hasNoResults,
  hasNoSearchResults,
  getHeading,
  showModelSummary,
  getModelSummary,
  showRatings,
  getPagination,
  getPageLevel,
  showOverlay,
  hideResultCount,
  getLoadingType,
  getSeoTextBlock,
} from "../../store/results/selectors";

import { canSortResults, getSortOptions } from "../../store/filters/selectors";

import { updateFilters, updatePage, updateSort } from "../../store/search/actions";
import { saveToShortlist, initShortlist } from "../../store/shortlist/actions";
import { getShortlistData } from "../../store/shortlist/selectors";
import { getShortlistModals } from "../../store/content/selectors";
import { loadMore } from "../../store/results/actions";
import { getSearchUsageType } from "../../store/search/selectors";

const mapStateToProps = state => {
  const { seoTextBlock = null, displayMoreText = null, linesToDisplay = null } = getSeoTextBlock(
    state,
  );
  return {
    isLoading: isResultsLoading(state),
    isLoadingMore: isLoadingMoreResults(state),
    showOverlay: showOverlay(state),
    loadingType: getLoadingType(state),
    hideResultCount: hideResultCount(state),
    cars: getCars(state),
    calculationParameters: getCalculationParams(state),
    shortlistModals: getShortlistModals(state),
    shortlistData: getShortlistData(state),
    resultCount: getResultCount(state),
    seoTextBlock,
    displayMoreText,
    linesToDisplay,
    noResults: hasNoResults(state),
    noSearchResults: hasNoSearchResults(state),
    heading: getHeading(state),
    sortOptions: getSortOptions(state),
    canSortResults: canSortResults(state),
    showModelSummary: showModelSummary(state),
    modelSummary: getModelSummary(state),
    showRatings: showRatings(state),
    pagination: getPagination(state),
    calculationSummary: getCalculationSummary(state),
    pageLevel: getPageLevel(state),
    usageType: getSearchUsageType(state)
  };
};

const mapDispatchToProps = dispatch => ({
  updateFilters: o => dispatch(updateFilters(o)),
  updateSort: o => dispatch(updateSort(o)),
  saveToShortlist: o => dispatch(saveToShortlist(o)),
  initShortlist: o => dispatch(initShortlist(o)),
  updatePage: o => dispatch(updatePage(o)),
  loadMore: o => dispatch(loadMore(o)),
});

export const SearchResultsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchResults);
